<template>
  <div id="app">
    <header>
        <img src="@/assets/img/logo.png" alt="애프터닥 로고" />
      </header>
    <router-view />
  </div>
</template>

<script>
export default {
  name: "App"
};
</script>

<style>
@import "./assets/css/main.css";
</style>
